import {
  AppState,
  EngagementPhase,
  PreEngagementData,
  changeEngagementPhase,
  changeExpandedStatus,
  updatePreEngagementData,
} from ".";
import {useDispatch, useSelector} from "react-redux";
import {useGetWebchatAvailableQuery} from "~/api/requests";
import NiceModal from "@ebay/nice-modal-react";
import ContactUsDialog from "~/components/contact-us/ContactUsDialog";
import {useAuth} from "@bounce/shared/contexts";
import {env} from "@bounce/shared/constants";

export const useWebchat = () => {
  const dispatch = useDispatch();
  const expanded = useSelector((state: AppState) => state.session.expanded);
  const {loggedIn} = useAuth();
  const isRunningLocal = import.meta.env.DEV;
  const alwaysAllow = env == "staging" || env == "local";
  const {data: isWebchatAvailable} = useGetWebchatAvailableQuery({}, {enabled: !isRunningLocal});
  const openChat = ({data}: {data?: Partial<PreEngagementData>}) => {
    if (isWebchatAvailable || alwaysAllow) {
      if (data) {
        dispatch(updatePreEngagementData(data));
        dispatch(changeEngagementPhase({phase: EngagementPhase.StartChatWithMessage}));
      }
      dispatch(changeExpandedStatus({expanded: !expanded}));
    } else {
      NiceModal.show(ContactUsDialog, {fetchContact: loggedIn});
    }
  };

  return {openChat};
};
